import { useState, useEffect } from 'react';
import config from '../config';

export const useVisitorCount = () => {
    const [counts, setCounts] = useState({ total: 0, week: 0, loading: true });

    useEffect(() => {
        const fetchCounts = async () => {
            try {
                // Generate/retrieve unique visitor ID to handle shared IPs (proxies)
                let visitorId = localStorage.getItem('taxeases_visitor_id');
                if (!visitorId) {
                    visitorId = 'v_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
                    localStorage.setItem('taxeases_visitor_id', visitorId);
                }

                // Use relative path - this works in dev (via proxy) and prod (via server routing)
                const response = await fetch(`/api/visitor-count?vid=${visitorId}`);
                const data = await response.json();
                if (data.success) {
                    setCounts({
                        total: data.count,
                        week: data.weekCount,
                        loading: false
                    });
                }
            } catch (error) {
                console.error('Error fetching visitor count:', error);
                setCounts(prev => ({ ...prev, loading: false }));
            }
        };

        fetchCounts();
    }, []);

    return counts;
};
